import { DeliveryDate } from '@/resources/types'
import { format, parseISO } from 'date-fns'

export const formatDeliveryDate = (deliveryDate: DeliveryDate) => {
  return `${format(parseISO(deliveryDate.startDate as string), 'dd/MM, HH')}h - ${format(parseISO(deliveryDate.endDate as string), 'HH')}h`
}

export const hasDeliveryDate = (deliveryDate: DeliveryDate | null) => {
  return Boolean(deliveryDate && deliveryDate.startDate && deliveryDate.endDate)
}
